/**
 * Shared cookie configuration for both Cloudflare Worker and Next.js Middleware
 * Ensures consistent cookie behavior across environments
 *
 * IMPORTANT: These cookies must be whitelisted in Cookie-Script dashboard
 * to prevent them from being deleted by the consent management script.
 * Add them as "Strictly Necessary" or "Functional" cookies.
 */

export const COOKIE_CONFIG = {
  LOCALE: {
    name: 'next-locale',
    maxAge: 60 * 60 * 24 * 365, // 1 year - long-term language preference
  },
  AB_TEST: {
    name: 'next-ab-test',
    maxAge: 120, // 2 minutes
    enabled: false, // Disabled to reduce cache entries (1 per locale instead of 2)
  },
} as const;
